import { Heading, VStack, Input, Button, Box, Table, Thead, Tbody, 
  Tr, Th, Td, 
  Select, useToast, Checkbox, 
  IconButton,
  Text, useColorModeValue, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton, Collapse, HStack } from '@chakra-ui/react';
import React, { useState, useEffect, useCallback } from 'react';
import { ChevronUpIcon, ChevronDownIcon } from "@chakra-ui/icons";
import axios from 'axios';
import { Tooltip } from "@chakra-ui/react";
import { jwtDecode } from "jwt-decode";
import { format } from 'date-fns';
import { useNavigate } from "react-router-dom";
import { FiEdit, FiCheck, FiX, FiTrash } from "react-icons/fi";
import { Category } from '../../Platform/Common/types';

// Define the expected structure of the token payload
interface TokenPayload {
  sub: string;       // Typically the username or user ID
  role_code: string;   // Role ID
  exp?: number;      // Expiration timestamp (optional)
}

type OperationMode = "none" | "resequence" ;

const B2CCategoryManager = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const navigate = useNavigate();

  const toast = useToast();
  const tableHeaderbg = useColorModeValue("gray.200", "gray.700");

  const [operationMode, setOperationMode] = useState<OperationMode>("none");

  const [needsResequence, setNeedsResequence] = useState(false);


  // Fetch enrolled students when tenant ID is set
const fetchCategories = useCallback(async () => {
  try {
    const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
    const response = await axios.get(`${b2c_apiurl}/categories`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('b2c_token')}`,
      },
    });
    setCategories(response.data);
  } catch (error) {
    console.error("Failed to load B2C Categories", error);
  }
}, []);

useEffect(() => {
  fetchCategories();
}, [fetchCategories]);

useEffect(() => {
  if (needsResequence) {
    handleSequenceCommit();
    setNeedsResequence(false);
  }
}, [categories, needsResequence]);

  const handleDeleteCategory = async (category_id: number) => {
    // Placeholder function
       try {
         const apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
       console.log("Printing Token from Delete" + localStorage.getItem("b2c_token"));
       await axios.delete(apiurl + `/category/${category_id}`, {
         headers: {
           Authorization: `Bearer ${localStorage.getItem('b2c_token')}`
         }
       });
       // Immediately remove from local state BEFORE resequencing
      // setCategories(prev => prev.filter(c => c.category_id !== category_id));

       await fetchCategories();

       setNeedsResequence(true);   // trigger resequence
       toast({ title: "B2C Category deleted successfully", status: "success" });
     } catch (err: any) {
    console.error(err);

        const message =
          err?.response?.data?.detail ||
          "Error deleting category";

        toast({
          title: message,
          status: "error",
        });
      }
    };

  const handleAddNewCategory = () => {
/*     setIsAddingNew(true);
    setNewCategory({ 
      category_id: 0, 
      name: '', 
      slug:'', 
      description: '',  
      sequence:categories.length+1, 
      meta_description:'', 
      meta_title:'' , 
      is_active: true, 
      created_at: new Date(), 
      updated_at: new Date()
    }); */
        const category_id = 0;
    navigate(`/practice/app/b2c-category/${category_id}/review-category/`);
  };



  const handleSaveCategory = async (category: Category) => {
    try {

        const payload = {
            name: category.name,
            description: category.description,
            is_active: category.is_active,
            slug: category.slug,
            sequence: category.sequence,
            meta_description: category.meta_description,
            meta_title: category.meta_title,
            created_at: category.created_at,
            updated_at: category.updated_at,
        };
      const apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
      
      console.log("printing category user payload",payload);

      const response = await axios.post(apiurl+`/create-category/`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('b2c_token')}`
        }
      });
      setCategories([...categories, response.data]);

      toast({ title: "Category added successfully", status: "success" });
    } catch (error) {
      console.error("Failed to save Category ", error);
      toast({ title: "Failed to add Category ", status: "error" });
    }
  };

  const handleUpdateCategory = async (category: Category) => {
    try {
        const payload = {
            name: category.name,
            description: category.description,
            is_active: category.is_active,
            slug: category.slug,
            sequence: category.sequence,
            meta_description: category.meta_description,
            meta_title: category.meta_title,
            created_at: category.created_at,
            updated_at: category.updated_at,
        };
      const apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
     
      console.log("Printing Token from Update" + localStorage.getItem("b2c_token"));
      await axios.put(apiurl+`/update-category/${category.category_id}`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('b2c_token')}`
        }
      });
      fetchCategories();

      toast({ title: "Category updated successfully", status: "success" });
     } catch (err: any) {
    console.error(err);

        const message =
          err?.response?.data?.detail ||
          "Error updating category";

        toast({
          title: message,
          status: "error",
        });
      }
    };



    const handleCancelOperation = () => {
    fetchCategories();
    setOperationMode("none");
    }

      const handleMoveUp = (index: number) => {
        if (index === 0 || operationMode !== "resequence") return;
        const updated = [...categories];
        [updated[index - 1], updated[index]] = [updated[index], updated[index - 1]];
        setCategories(updated);
      };
      const handleMoveDown = (index: number) => {
        if (index === categories.length - 1 || operationMode !== "resequence") return;
        const updated = [...categories];
        [updated[index + 1], updated[index]] = [updated[index], updated[index + 1]];
        setCategories(updated);
      };
    
      // Commit handler:  resequence 
      const handleSequenceCommit = async () => {
        const apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
        const token = localStorage.getItem("b2c_token");
        try {

            // Resequence: compute new order from current questions list
            const updatedSequence = categories.map((ct, i) => ({
              category_id: ct.category_id,
              sequence_number: i + 1,
            }));
            console.log("printing category user resequence order",updatedSequence);
            await axios.put(`${apiurl}/categories/reorder`, updatedSequence, {
              headers: { Authorization: `Bearer ${token}` },
            });
            toast({
              title: "New order committed",
              status: "success",
              duration: 3000,
              isClosable: true,
            });
    
          // Refresh data
          await fetchCategories();
          setOperationMode("none");

        } catch (error) {
          toast({
            title: `Failed to ${operationMode} questions`,
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        }
      };

  const handleReviewDomains = (category_id: number) => {

    navigate(`/practice/app/b2c-category/${category_id}/domains`);

  };

  const handleReviewCategory = (category_id: number) => {
      navigate(`/practice/app/b2c-category/${category_id}/review-category`);
    };


  return (
    <Box as="main" mx="auto" p={10} >
      <VStack>
        <Heading size={"md"}>B2C Category Manager</Heading>
      </VStack>
        <Box mt={4}>
          <Text fontWeight="bold">Existing B2C Categories</Text>
          <HStack mt={2}>
            <Button   borderRadius={"sm"} fontSize="sm" fontWeight="normal" onClick={handleAddNewCategory} isDisabled={operationMode === "resequence" }>
              + B2C Category
            </Button>
            <Button
              borderRadius={"sm"} fontSize="sm" fontWeight="normal"
              onClick={() => {
                setOperationMode("resequence");
              }}
              isDisabled={operationMode === "resequence" }
            >
              Resequence Categories
            </Button>

          </HStack>

          {(operationMode !== "none") && (
            <HStack mt={4} spacing={3}>
          <Button
            size="sm"
            colorScheme="blue"
            onClick={handleSequenceCommit}
          >
            Commit
          </Button>
            <Button size={"sm"} variant="outline" colorScheme="red" onClick={handleCancelOperation}>
              Cancel
            </Button>
            </HStack>
          )}

      </Box>
      <Box mt={4}>
       
        <Table mt={4} borderColor={"gray.300"} borderWidth={1} borderRadius="sm">
          <Thead fontSize="12">
            <Tr bgColor={tableHeaderbg}>
              <Th>ID</Th>
              <Th>Sequence</Th>
              <Th>Category Name</Th>
                <Th>Category Slug</Th>
              <Th>Description</Th>

             <Th>Meta Title</Th>
             <Th>Meta Description</Th>

              <Th>Status</Th>
              {/* <Th>Created At</Th>
              <Th>Updated At</Th> */}
             
            <Th>Actions</Th>
            <Th>Domains</Th>
            </Tr>
          </Thead>
          <Tbody fontSize="12">

            {categories.map((category,index) => (
                <Tr
                key={category.category_id}
              
                >
                <Td>{category.category_id}</Td>
                <Td>{category.sequence}</Td>
                <Td>
                    {
                        category.name
                    }
                </Td>
                <Td>
                    {
                        category.slug
                    }
                </Td>
                <Td>
                    {
                        category.description
                    }
                </Td>



                <Td>
                    {
                        category.meta_description
                    }
                </Td>

             <Td>
                    {
                        category.meta_title
                    }
                </Td>

                <Td>
                    {category.is_active ? (
                        "Active"
                        ) : (
                        "Inactive")
                        }
                </Td>
                
                <Td>

                  {operationMode === "resequence" && (
                    <>
                      <IconButton
                        size="xs"
                        icon={<ChevronUpIcon />}
                        aria-label="Move Up"
                        onClick={e => { e.stopPropagation(); handleMoveUp(index); }}
                      />
                      <IconButton
                        size="xs"
                        icon={<ChevronDownIcon />}
                        aria-label="Move Down"
                        onClick={e => { e.stopPropagation(); handleMoveDown(index); }}
                      />
                    </>
                  )}

                {operationMode === "none" && (
                   <>
                    
                       
                    <Tooltip label="Edit">
                        <Button size="sm" onClick={() => handleReviewCategory(category.category_id)} mr={8}>
                        <FiEdit />
                        </Button>
                    </Tooltip>
                    <Tooltip label="Delete">
                    <Button
                            size="sm"
                            colorScheme="red"
                            onClick={() => {
                            if (window.confirm("Are you sure you want to delete this category?")) {
                                handleDeleteCategory(category.category_id);
                            }
                            }}
                        >
                            <FiTrash />
                        </Button>
                    </Tooltip>
                    </>
                  
                    
                    )}

                </Td>
                <Td>
                  <Tooltip label="Review Domains for the category">
                    <Button size="sm" onClick={() => handleReviewDomains(category.category_id)}>
                      Domains
                    </Button>
                  </Tooltip>
                </Td>
                </Tr>
                
            ))}

            </Tbody>

        </Table>
      </Box>

    </Box>
  );
};

export default B2CCategoryManager;
